import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const MetaTags: React.FC = () => {
  const metaTags = useSelector(select.cms.getMetaTags);
  return (
    <Helmet>
      {metaTags?.map(({ name, content }) => (
        <meta key={content} name={name} content={content} />
      ))}
    </Helmet>
  );
};

export default MetaTags;
